export const PASSWORD_REQUIREMENTS = [
  `At least 12 characters`,
  `A lowercase letter`,
  `An uppercase letter`,
  `A number`,
  `No parts of your username`,
  `Does not include your first name`,
  `Does not include your last name`,
  `Password can't be the same as your last 24 passwords`,
  `At least 2 hour(s) must have elapsed since you last changed your password`,
]
